import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://vxddvylcmazvlrcyumrh.supabase.co';
const SUPABASE_KEY = 'sb_publishable_kkxFDP4gPvVKnnJJ92MitA_W9EtC8pI';

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
export const BUCKET = 'superior-plumbing-assets';
